import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-data-export',
  templateUrl: './data-export.component.html',
  styleUrls: ['./data-export.component.scss']
})
export class DataExportComponent implements OnInit {

  @Output() exportData = new EventEmitter();

  constructor() { }

  exportCsvFile() {
    this.exportData.emit();
  }

  ngOnInit() {
  }

}
